import React from 'react';
import { Globe, Smartphone, Bot, Workflow, BarChart3, TrendingUp, Video, ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Services.css';
import { services } from '../data/mock';

const iconMap = {
  Globe,
  Smartphone,
  Bot,
  Workflow,
  BarChart3,
  TrendingUp,
  Video
};

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero */}
      <section className="services-hero">
        <div className="container text-center">
          <h1 className="display-large mb-3 fade-in">
            Comprehensive Digital Solutions for <span className="gradient-text">Modern Businesses</span>
          </h1>
          <p className="body-large fade-in" style={{ animationDelay: '0.1s' }}>
            From concept to deployment, we deliver enterprise-grade solutions that drive measurable results and sustainable growth.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section">
        <div className="container">
          <div className="services-detailed-grid">
            {services.map((service, index) => {
              const Icon = iconMap[service.icon];
              return (
                <div key={service.id} className="service-detailed-card glass-card fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="service-detailed-header">
                    <div className="service-detailed-icon">
                      <Icon size={40} />
                    </div>
                    <h2 className="heading-1">{service.title}</h2>
                  </div>
                  <p className="body-medium mb-3">{service.description}</p>
                  
                  <div className="service-features mb-3">
                    <h4 className="heading-3 mb-2">Key Features:</h4>
                    <ul className="features-list">
                      {service.features.map((feature, idx) => (
                        <li key={idx}>
                          <CheckCircle size={18} className="feature-check" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="service-benefits">
                    <div className="benefits-label">Business Impact:</div>
                    <p className="benefits-text">{service.benefits}</p>
                  </div>

                  <Link to="/contact" className="btn-primary btn-full mt-4">
                    Get Started
                    <ArrowRight size={20} />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section process-section">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="display-medium mb-2">Our Process</h2>
            <p className="body-large">A proven methodology for delivering exceptional results</p>
          </div>
          <div className="process-grid">
            <div className="process-step glass-card">
              <div className="step-number">01</div>
              <h3 className="heading-2 mb-2">Discovery & Strategy</h3>
              <p className="body-medium">
                We dive deep into your business goals, challenges, and requirements to create a tailored strategy that aligns with your vision.
              </p>
            </div>
            <div className="process-step glass-card">
              <div className="step-number">02</div>
              <h3 className="heading-2 mb-2">Design & Planning</h3>
              <p className="body-medium">
                Our team creates detailed wireframes, prototypes, and technical architecture to ensure a solid foundation for development.
              </p>
            </div>
            <div className="process-step glass-card">
              <div className="step-number">03</div>
              <h3 className="heading-2 mb-2">Development & Testing</h3>
              <p className="body-medium">
                Agile development with regular sprints, continuous testing, and transparent communication to keep you informed every step.
              </p>
            </div>
            <div className="process-step glass-card">
              <div className="step-number">04</div>
              <h3 className="heading-2 mb-2">Launch & Support</h3>
              <p className="body-medium">
                Seamless deployment followed by ongoing support, optimization, and maintenance to ensure long-term success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="container">
          <div className="services-cta glass-card text-center">
            <h2 className="display-medium mb-3">Not Sure Which Service You Need?</h2>
            <p className="body-large mb-4">
              Book a free consultation with our experts to discuss your unique requirements and get personalized recommendations.
            </p>
            <Link to="/contact" className="btn-primary btn-large">
              Schedule Free Consultation
              <ArrowRight size={22} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
